import { Component } from 'react';
import { Sentry } from '@/lib/sentry';

export default class ErrorBoundary extends Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught:', error, info);
    try {
      if (Sentry?.captureException) {
        Sentry.captureException(error, { extra: { componentStack: info?.componentStack } });
      }
    } catch {
      // Sentry not available, ignore
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex flex-col items-center justify-center min-h-[300px] p-8 text-center">
          <div className="text-4xl mb-4">&#9888;</div>
          <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-200 mb-2">Something went wrong</h2>
          <p className="text-sm text-slate-500 dark:text-slate-400 mb-4 max-w-md">
            {this.state.error?.message || 'An unexpected error occurred'}
          </p>
          <button
            onClick={() => { this.setState({ hasError: false, error: null }); }}
            className="px-4 py-2 text-sm font-medium text-white bg-brand rounded-xl hover:bg-brand/90 transition-colors"
          >
            Try again
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
